/**
 * Database Blueprint Workspace Module
 *
 * Registers the 'database-blueprint' workspace type and exports public APIs.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

registerWorkspaceComponent(
  'database-blueprint',
  lazyWorkspaceTab(() => import('./components/DatabaseBlueprintTab').then((m) => ({ default: m.DatabaseBlueprintTab }))),
);

export { DatabaseBlueprintToolbar } from './components/DatabaseBlueprintToolbar';
export { BlueprintFileTree } from './components/BlueprintFileTree';
export { BlueprintPeekViewer } from './components/BlueprintPeekViewer';
export { BlueprintObjectCountsBar } from './components/BlueprintObjectCountsBar';
export { BlueprintDriftPanel } from './components/BlueprintDriftPanel';
export { RefreshFromDbDialog } from './components/RefreshFromDbDialog';
export { GlobalRefreshFromDbDialog } from './components/GlobalRefreshFromDbDialog';
export { useRefreshFromDbDialogStore } from './store/refreshFromDbDialogStore';
export { SyncDataDialog } from './components/SyncDataDialog';
export { GlobalSyncDataDialog } from './components/GlobalSyncDataDialog';
export { useSyncDataDialogStore } from './store/syncDataDialogStore';
export { SyncDataProgressDialog } from './components/SyncDataProgressDialog';
export { GlobalSyncDataProgressDialog } from './components/GlobalSyncDataProgressDialog';
export { useSyncDataProgressDialogStore } from './store/syncDataProgressDialogStore';
export { ThreeWayMergeDialog } from './components/ThreeWayMergeDialog';
export { AddLinkedDbDialog } from './components/AddLinkedDbDialog';
export { BlueprintGitPanel } from './components/BlueprintGitPanel';
export { BlueprintGitConflictDialog } from './components/BlueprintGitConflictDialog';
export { useBlueprintFolder } from './hooks/useBlueprintFolder';
